import React from "react";
import { Flex, Heading, Text, Grid } from "@theme-ui/components";
import { typography } from "../../styles/theme";
import { ProfileCard } from "../molecules";

const EcosystemSection = ({
  ecosystemSectionTitle,
  ecosystemSectionDescription,
  ecosystems,
  code,
}) => {
  const onClick = (link) => {
    window.open(link, "_blank", "noopener,noreferrer");
  };
  return (
    <Flex sx={wrapperContainer}>
      <Heading
        as="h2"
        sx={{
          textAlign: "center",
          ...typography.h2,
          mb: "1.5rem",
          p:{m:0}
        }}
        dangerouslySetInnerHTML={{ __html: ecosystemSectionTitle }}
      />
      <Text
        sx={{ textAlign: "center", ...typography.textMd400, mb: "4.4rem" }}
        dangerouslySetInnerHTML={{ __html: ecosystemSectionDescription }}
      />
      <Grid columns={code === "ME" ? [1, 1, 2, 3] : [1, 1, 2, 2]}>
        {ecosystems.length > 0 &&
          ecosystems.map((ecosystem, index) => {
            return (
              <ProfileCard
                key={`profileCard-${index}`}
                name={ecosystem.title}
                bio={ecosystem.backContent}
                image={ecosystem.cardImages[0]}
                variant="fullImage"
                ctaTitle="Know More"
                onCTAClick={() => onClick(ecosystem?.learnMoreUrl)}
                customStyles={ProfileCardStyles}
              />
            );
          })}
      </Grid>
    </Flex>
  );
};

const wrapperContainer = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: "transparent",
};
const ProfileCardStyles = {
  height: "28.375rem",
  width: "100%",
  maxWidth: "23.3rem",
  ".card-image": { height: "95%" },
  ".profile-card-title": {
    ...typography.h5,
  },
};

export default React.memo(EcosystemSection);
